import React from 'react';
import { FileQuestion } from 'lucide-react';
interface ConversationTranscriptProps {
  conversationText: string;
  fileUrls: string[];
}

/** Full report: the exact source material the analyzer received. */
export function ConversationTranscript({
  conversationText,
  fileUrls
}: ConversationTranscriptProps) {
  if (!conversationText && fileUrls.length === 0) {
    return <div className="rounded-xl border border-dashed border-forensic-line p-8 text-center" data-id="element-127" data-mp="1e6ftukr24f05">
        <FileQuestion className="mx-auto text-forensic-subtle" size={28} aria-hidden="true" data-id="element-128" data-mp="1i8137w4dub5l" />
        <h3 className="mt-3 text-base font-semibold text-white" data-id="element-129" data-mp="1i5omtne9w8un">Conversation not on file</h3>
        <p className="mx-auto mt-1 max-w-md text-sm text-forensic-muted" data-id="element-130" data-mp="14am9wgb0dj8c">
          The original conversation wasn’t stored for this scan. Your analysis,
          evidence, and recommendations are still available in the other tabs.
        </p>
      </div>;
  }
  return <div className="space-y-6" data-id="element-131" data-mp="3tz50ag7fulyk">
      {conversationText && <section className="rounded-xl border border-forensic-line bg-forensic-surface p-5 sm:p-6" data-id="element-132" data-mp="1shxpm00wrorg">
          <h3 className="text-lg font-semibold text-white" data-id="element-133" data-mp="1ohvz8n0mihrh">Complete conversation</h3>
          <p className="mt-1 text-sm text-forensic-muted" data-id="element-134" data-mp="22hesyasotqk9">The exact text the analyzer received.</p>
          <pre className="mt-4 max-h-[32rem] overflow-y-auto whitespace-pre-wrap break-words rounded-lg border border-forensic-line bg-forensic-bg p-4 font-mono text-sm leading-relaxed text-gray-300" data-id="element-135" data-mp="1xh993gsnt8cq">
            {conversationText}
          </pre>
        </section>}

      {fileUrls.length > 0 && <section className="rounded-xl border border-forensic-line bg-forensic-surface p-5 sm:p-6" data-id="element-136" data-mp="2l7mqmddmbot2">
          <h3 className="text-lg font-semibold text-white" data-id="element-137" data-mp="2g80cm1pyu4j7">
            Submitted screenshots ({fileUrls.length})
          </h3>
          <div className="mt-4 grid grid-cols-2 gap-3 md:grid-cols-3" data-id="element-138" data-mp="2v62i4hgk5033">
            {fileUrls.map((url, i) => <a key={url} href={url} target="_blank" rel="noopener noreferrer" className="block aspect-square overflow-hidden rounded-lg border border-forensic-line transition-colors duration-150 ease-out hover:border-white/30" data-id="element-139" data-mp="2q8aqzpnqlhzy" data-mpi={i}>
                <img src={url} alt={`Submitted screenshot ${i + 1}`} className="h-full w-full object-cover" loading="lazy" data-id="element-140" data-mp="3byk98rqoyiyt" />
              </a>)}
          </div>
        </section>}
    </div>;
}